import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/components/reko/LoginPage";
import AppShell from "@/components/reko/AppShell";
import CookieBanner from "@/components/reko/CookieBanner";
import { CookiesPage, PrivacyPage, TermsPage } from "@/components/reko/LegalPages";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
        <div className="text-sm text-slate-500 font-medium">Laddar...</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster richColors position="top-right" />
      <BrowserRouter>
        <CookieBanner />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/villkor" element={<TermsPage />} />
          <Route path="/integritet" element={<PrivacyPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/*" element={<Protected><AppShell /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
